// extracted by mini-css-extract-plugin
export default {"fontSizeSelector":"fontSizeSelector---VUdri"};